'use strict';

export default class Payment {
  constructor() {

    $('#PaymentForm').ajaxForm(
      {
        success:SendPaymentToQuickWeb,
        error:ErrorMessage,
        type:'POST'
      }
    );

    function SendPaymentToQuickWeb(responseText, statusText, xhr, $form) {
      var json = $.parseJSON(xhr.responseText);

      if (json.Result == true) {
        window.location = json.RedirectUrl;
      }
      else {
        $('#referenceNumberError').text(json.Error || "Something went wrong while processing the request.");
      }
    }

    function ErrorMessage (xhr, ajaxOptions, thrownError) {
      var json = {};
      try
      {
        json = $.parseJSON(xhr.responseText);
      }
      catch(err){
        //was not passed back valid Json, we will just display a generic error message in this case.
      }

      $('#referenceNumberError').text(json.Error || "Something went wrong while processing the request.");
    }
  }
}
